import React, { useState } from "react";
import { FilePlus2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../ui/button";
import { adminApi, formatApiError, useAuth } from "../../../context/AuthContext";
import { CustomsInvoiceDialog } from "./CustomsInvoiceDialog";

export const CustomsInvoiceAction = ({ consolidationId = null, shipmentIds = [], onChanged, onClose }) => {
  const { hasPermission } = useAuth();
  const [busy, setBusy] = useState(false);
  const [doc, setDoc] = useState(null);
  const canCreate = hasPermission(consolidationId ? "consolidations:edit" : "shipments:edit");
  if (!canCreate) return null;
  const create = async () => {
    setBusy(true);
    try {
      const { data } = await adminApi.post(consolidationId
        ? `/admin/consolidations/${consolidationId}/customs-invoices`
        : "/admin/warehouse-shipments/customs-invoices", consolidationId ? {} : { shipment_ids: shipmentIds });
      setDoc(data); onChanged?.(data);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };
  return <>
    <Button size="sm" variant="outline" onClick={create} disabled={busy || (!consolidationId && !shipmentIds.length)}
      className="max-w-full text-xs" data-testid={consolidationId ? "consolidation-create-customs-invoice" : "warehouse-create-customs-invoice"}>
      {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <FilePlus2 className="mr-1 h-4 w-4" />}Douanefactuur maken
    </Button>
    {doc && <CustomsInvoiceDialog document={doc} onClose={() => { setDoc(null); onClose?.(); }} onChanged={onChanged} />}
  </>;
};